import { enqueueSnackbar } from 'notistack';
import { useAppDispatch } from '../../../../../../hooks/reduxHooks';
import { showAlert } from '../../../../../../features/slices/applicationSlice';
import { ALERT_CONFIRM_TEXT, ERROR_CONTACT_SUPPORT } from '../../../../../../constants/values';
import { useAssignReconfirmationEmployeeExamMutation } from '../../../../../../services/periodicosApi';
import { handleErrors } from '../../../../../../utils/common';
import useReconfirmationExamDrawerForm from './useReconfirmationExamDrawerForm';

const useReconfirmationExamDrawer = ({handleCloseDrawer}: any) => {
    const reconfirmationExam = useReconfirmationExamDrawerForm();
    const [assignReconfirmationExam, { isLoading: isAssigningExam }] =
        useAssignReconfirmationEmployeeExamMutation({});
    const dispatch = useAppDispatch();

    const { formData, fieldsConfig, validateForm } = reconfirmationExam;

    const handleSave = async (selectedEmployee: any) => {
        if (!validateForm(formData, fieldsConfig) || !selectedEmployee) {
            return;
        }

        try {
            const adaptedBody = {
                nombre: formData?.examName
            };

            const response: any = await assignReconfirmationExam({
                idEmpleado: selectedEmployee?.id,
                body: adaptedBody
            });
            if (response?.error) {
                handleErrors(response.error);
                return;
            }
            enqueueSnackbar('Exámen asignado con éxito!', { variant: 'success' });
            handleCloseDrawer();
        } catch (error) {
            dispatch(
                showAlert({
                    title: 'No se pudo asignar el examen de reconfirmación',
                    message: ERROR_CONTACT_SUPPORT,
                    icon: 'error',
                    confirmText: ALERT_CONFIRM_TEXT
                })
            );
        }
    };

    return { reconfirmationExam, isAssigningExam, handleSave };
};

export default useReconfirmationExamDrawer;
